import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, Form, getFormValues } from 'redux-form'
import { makeStyles } from '@material-ui/core'

import { getUsers } from '../store/users/actions'
import { showAlertMessage } from '../store/alert/actions'
import {
  createPickupAuthorizationRSPA,
  editPickupAuthorizationRSPA,
  // getPickupAuthorizations,
  // deleteAuthorization,
  getAuthorization,
  clearCurrentAuthorization
} from '../store/pickup/actions'
import { getChildrenRSPA } from '../store/classrooms/actions'

import CreatePickupAuthorizationsForm from '../components/form/CreatePickupAuthorizationsForm'

const useStyles = makeStyles(theme => ({
  root: {
    width: '96%',
    height: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: '56px 32px',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  page_description: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    marginBottom: 72,
    '& h1': {
      margin: 0,
      fontWeight: 700,
      fontSize: 32,
      color: '#4D5E80'
    },
    '& p': {
      margin: 0,
      fontWeight: 400,
      fontSize: 16,
      color: '#9B9B9B'
    }
  }
}))

const PageTitle = ({ isEdit }) => {
  if (isEdit) {
    return <h1>Editar autorização</h1>
  }
  return <h1>Criar nova autorização</h1>
}

const CreatePickupAuthorizationPage = ({
  match,
  schoolId,
  getChildrenRSPA,
  currentUser,
  fieldValues,
  initialValues,
  valid,
  editPickupAuthorizationRSPA,
  createPickupAuthorizationRSPA,
  currentAuthorization,
  getAuthorizationById,
  getUsers,
  alert,
  clearCurrentAuthorization
}) => {
  const classes = useStyles()
  const authorizationId = match.params.id

  React.useEffect(
    () => {
      if (authorizationId) {
        getAuthorizationById({ id: authorizationId })
      }
    },
    [authorizationId]
  )

  return (
    <div className={classes.root}>
      <div className={classes.page_description}>
        <PageTitle isEdit={!!authorizationId} />
        <p>Adicione quem poderá retirar o aluno.</p>
      </div>
      <Form>
        <CreatePickupAuthorizationsForm
          initialValues={initialValues}
          isEdit={!!authorizationId}
          currentAuthorization={currentAuthorization}
          clearCurrentAuthorization={clearCurrentAuthorization}
          getChildrenRSPA={getChildrenRSPA}
          schoolId={schoolId}
          currentUser={currentUser}
          fieldValues={fieldValues}
          valid={valid}
          editPickupAuthorizationRSPA={editPickupAuthorizationRSPA}
          createPickupAuthorizationRSPA={createPickupAuthorizationRSPA}
          getUsers={getUsers}
          getAuthorizationById={getAuthorizationById}
          alert={alert}
        />
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    userOccupations: state.auth.currentOccupation,
    fieldValues: getFormValues('createPickupAuthorizationForm')(state),
    currentUser: state?.auth?.user?.data,
    schoolId: state.school?.currentSchool?.school_id,
    authorizations: state.authorizations,
    currentAuthorization: state.authorizations.currentItem,
    initialValues: { ...state.authorizations.currentItem }
  }
}

const mapDispatchToProps = dispatch => ({
  getChildrenRSPA: data => dispatch(getChildrenRSPA.request(data)),
  editPickupAuthorizationRSPA: data =>
    dispatch(editPickupAuthorizationRSPA.request(data)),
  clearCurrentAuthorization: data => dispatch(clearCurrentAuthorization(data)),
  getAuthorizationById: data => dispatch(getAuthorization(data)),
  getUsers: data => dispatch(getUsers.request(data)),
  createPickupAuthorizationRSPA: data =>
    dispatch(createPickupAuthorizationRSPA.request(data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createPickupAuthorizationForm',
    enableReinitialize: true,
    touchOnChange: true,
    touchOnBlur: true,
    onSubmit: async (values, dispatch, props) => {}
  })(CreatePickupAuthorizationPage)
)
